LocalStorageModel = require 'app/scripts/view-models/internal/local-storage-model'

module.exports = class ListComposer extends LocalStorageModel
  constructor: (board, options) ->
    super(null, options)
    @board = board
    @waitForId @board, (idBoard) =>
      @set({ id: "boardListComposerSettings-#{ idBoard }" })
      @fetch()

  default: ->
    title: null
    vis: false

  clear: ->
    @save(@default())

  clearItems: ->
    @save({
      title: ""
    })
    return

  getBoard: ->
    @board

  toJSON: ({ board, list } = {}) ->
    json = super
    if board
      json.board = @getBoard().toJSON()
    json
